import { render, staticRenderFns } from "./QuotesDataTable.vue?vue&type=template&id=0bddddd8"
import script from "./QuotesDataTable.vue?vue&type=script&lang=js"
export * from "./QuotesDataTable.vue?vue&type=script&lang=js"
import style0 from "./QuotesDataTable.vue?vue&type=style&index=0&id=0bddddd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports